export const MAX_PURCHASE_AMT = 999999;
export const MAX_QUANTITY = 9999999;
export const MIN_PURCHASE_AMT = 2;
export const MAX_MEDIA_UPLOAD = 10;
export const MAX_MEDIA_AMT = 10;
